import styled from "styled-components"

export const ErrorMsg = styled.span`
    font-size: 12px;
    color: red;
`;